import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "../components/login/login";
import { useParams } from "react-router-dom";
import { signupUrlExample } from "../constants";
import ErrorPage from "./error";
import ScreenPagePart from "../components/login/screenpage";
import PreloaderPage from "./preloader";
import { backend } from "../services/backend";

const SignupPage = () => {
  const { id } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);
  const [linkData, setLinkData] = useState<any>()


  useEffect(() => {
    if (!id) {
      setErrored(true);
      return;
    }
     console.log("Requesting:")
     backend.checkInviteLink(id).then((data) => {
      console.log(data)
      if (!data || data.error) {
        console.log("Errored")
        setErrored(true);
        setLoaded(true)
        return;
      }
      setLinkData(data)
      setLoaded(true)
     }).catch(() => {
       setErrored(true);
     })
  }, [id])


  if (errored) {
    return(
        <ErrorPage
          code={404}
          message={"Недействительная ссылка для регистрации"}
        />
    )
  }

  if (!loaded) {
    return(
      <PreloaderPage />
    )
  }

  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        <div>
          <div className="signupInfoBlock">
            <p>Подразделение: {linkData.group_name}</p>
            <p>Должность: {linkData.role_name}</p>
          </div>
          <LoginForm isSignup={true} link={id} />
        </div>
      </div>
    </ScreenPagePart>
  );
};

export default SignupPage;
